<div class="video-modal">
    <div class="video-wrapper-popup">
        <iframe [src]="convertToSafeUrl()" frameborder="0" title="Video name" webkitallowfullscreen mozallowfullscreen
            allowfullscreen allow=autoplay></iframe>
    </div>
</div>